import { createClient } from '@supabase/supabase-js';

// Récupérer les variables d'environnement
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Vérifier si les variables d'environnement sont définies
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('⚠️ Variables d\'environnement Supabase manquantes!');
  console.error('Assurez-vous d\'avoir défini VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY dans votre fichier .env.local');
}

// Options de configuration pour le client Supabase
const supabaseOptions = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
};

// Créer le client Supabase
export const supabase = createClient(supabaseUrl, supabaseAnonKey, supabaseOptions);

// Vérification de la connexion Supabase (utile pour le debug)
export const checkSupabaseConnection = async () => {
  try {
    const { error } = await supabase.from('events').select('id').limit(1);
    if (error) {
      console.error('❌ Erreur de connexion à Supabase:', error.message);
      return false;
    }
    console.log('✅ Connexion Supabase établie avec succès');
    return true;
  } catch (err) {
    console.error('❌ Exception lors de la connexion à Supabase:', err.message);
    return false;
  }
};
